import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { title } from '@core/utils/filter'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useUsersList(courseid) {
  //console.log("initiel course Id" +courseid);
  // Use toast
  const toast = useToast()

  const refUserListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    { key: 'createdAt', class:"cols-1", label:" Date", sortable: true },
    { key: 'clientmembername', class:"cols-2", label:"Member", sortable: true },
  
    { key: 'suggestionSubject', class:"cols-3", label:"Subject", sortable: true },
    { key: 'formStatus', class:"cols-3", label:"Status", sortable: true },
    { key: 'actions', class:"cols-3", label:"Action", sortable: true },
  
    
   
    
  ]
  const perPage = ref(10)
  const totalUsers = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  const roleFilter = ref(null)
  const planFilter = ref(null)
  const statusFilter = ref(null)
  const courseId = ref(courseid)

  const dataMeta = computed(() => {
    const localItemsCount = refUserListTable.value ? refUserListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalUsers.value,
    }
  })

  const refetchData = () => {
    refUserListTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery, roleFilter, planFilter, statusFilter,courseId], () => {
    refetchData()
  })

  const fetchSuggestions = (ctx, callback) => {
    store
      .dispatch('apps-suggestions/fetchAllSuggestions', {
     
      })
      .then(response => {
        const { data, total } = response.data
//console.log("some resposne");
        callback(data)
        totalUsers.value = total
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching users list',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

 
 


  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  const resolveUserRoleVariant = role => {
    if (role === 'subscriber') return 'primary'
    if (role === 'author') return 'warning'
    if (role === 'maintainer') return 'success'
    if (role === 'editor') return 'info'
    if (role === 'admin') return 'danger'
    return 'primary'
  }

  const resolveUserRoleIcon = role => {
    if (role === 'subscriber') return 'UserIcon'
    if (role === 'author') return 'SettingsIcon'
    if (role === 'maintainer') return 'DatabaseIcon'
    if (role === 'editor') return 'Edit2Icon'
    if (role === 'admin') return 'ServerIcon'
    return 'UserIcon'
  }

  const resolveUserStatusVariant = status => {
    if (status ===0) return 'info'
    if (status ===1) return 'warning'
    if (status === 100) return 'success'
    if (status === 200) return 'danger'
    return 'primary'
  }
  const resolveUserStatusVariantText = status => {
    if (status ===0) return 'NEW'
    if (status ===1) return 'In Progress'
    if (status === 100) return 'Confirmed'
    if (status === 200) return 'Rejected'
    return 'primary'
  }

  return {
    fetchSuggestions,
    tableColumns,
    perPage,
    currentPage,
    totalUsers,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refUserListTable,

    resolveUserRoleVariant,
    resolveUserRoleIcon,
    resolveUserStatusVariant,
    resolveUserStatusVariantText,
    refetchData,

    // Extra Filters
    roleFilter,
    planFilter,
    statusFilter, 
    courseId, 
  }
}
